// This script will be lazy loaded with async script
import Svg from "../../svg/lazy/lazySvgDefinition.svg";

$("body").prepend(Svg);


// WEBPACK FOOTER //
// ./js/lazy-load/SvgLazyLoad.js